






















import { GuideStep } from '@/models/guides';
import { Actions} from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'NickSet',
  props: {
    step: Object as () => GuideStep,
  },
  data() {
    return {
      form: {
        nick: '' as string,
      },
    };
  },
  methods: {
    async applyChanges() {
      if (this.form.nick) {
        await this.$store.dispatch(Actions.geek.setNick, this.form.nick);
        await this.$store.dispatch(Actions.guides.fetchGuideUserBasicInfo);
      }
    },
  },
});
